import { IconButton, Typography } from "@material-ui/core";
import Grow from "@material-ui/core/Grow";
import InputBase from "@material-ui/core/InputBase";
import { fade, makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {},
  search: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    height: 40,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.common.white,
    color: theme.palette.grey[800],
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.75),
    },
    marginLeft: 0,
    width: 280,
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.grey[800],
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    width: "100%",
  },
  cleareButton: {
    height: "100%",
    position: "relative",
    right: 0,
    top: 0,
  },
  hint: {
    marginLeft: 5,
    marginTop: 2,
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  },
}));

interface Props {
  value: string | undefined;
  onSearchChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => any;
  onClearSearch: () => any;
  ignoreLength?: boolean;
  hint?: string;
}

const SearchField: React.FC<Props> = ({
  value,
  onSearchChange,
  onClearSearch,
  ignoreLength,
  hint,
}) => {
  const classes = useStyles();
  const [localSearchValue, setLocalSearchValue] = React.useState<
    string | undefined
  >(value);

  return (
    <div className={classes.root}>
      <div className={classes.search}>
        <div className={classes.searchIcon}>
          <SearchIcon />
        </div>
        <InputBase
          value={localSearchValue}
          placeholder="Suche..."
          onChange={(event) => {
            if (event.target.value.length > 2 || ignoreLength) {
              onSearchChange(event);
            }
            setLocalSearchValue(event.target.value);
          }}
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
          inputProps={{ "aria-label": "search" }}
        />
        <Grow
          in={!!value}
          style={{ transitionDelay: !!value ? "100ms" : "0ms" }}
        >
          <IconButton
            onClick={() => {
              setLocalSearchValue("");
              onClearSearch();
            }}
            className={classes.cleareButton}
          >
            <CloseIcon />
          </IconButton>
        </Grow>
      </div>
      <Typography
        variant="caption"
        color="textSecondary"
        className={classes.hint}
      >
        {hint}
      </Typography>
    </div>
  );
};

export default SearchField;
